import React from 'react';
import Screens from 'shared/screens';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import QueryParamsProxy from 'shared/utils/queryParamProxy';
import RouteParamConstants from 'shared/utils/routeParamConstants';
import { useTheme } from 'styled-components';
import {
  CardsImage,
  CardsImageContainer,
  Divider,
  SportsAccessButtons,
  SportsAccessContainer,
  SportsAccessHeader,
  SportsAccessInfo,
  StyledButton,
} from './styledComponents';

const SportsAccessFlow = () => {
  const themeContext = useTheme();

  const redeemSportsAccess = () => {
    QueryParamsProxy.setQueryParams({
      [RouteParamConstants.PARAM_MODAL]: Screens.LinkAccountForm,
    });
  };

  return (
    <SportsAccessContainer>
      <CardsImageContainer>
        <CardsImage alt="" src={assetSource(ASSET_KEY.CARDS_ACCESS_RESTRICTED)} />
      </CardsImageContainer>
      <SportsAccessHeader>{getText(TEXT_KEY.SPORTS_ACCESS_MODAL_TTILE)}</SportsAccessHeader>
      <Divider alt="" src={assetSource(ASSET_KEY.DIVIDER_ACCESS_RESTRICTED)} />
      <SportsAccessInfo>
        {getText(TEXT_KEY.SPORTS_ACCESS_MEMBER)}
        <br />
        {getText(TEXT_KEY.SPORTS_ACCESS_LINK_CARD)}
      </SportsAccessInfo>
      <SportsAccessButtons>
        <StyledButton
          imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
          textStroke={BUTTON_STROKES.QUATERNARY}
          imageStyle={themeContext.SportsAccessFlow.SportsAccessButtonImage}
          label={getText(TEXT_KEY.LINK_CARD)}
          onClick={redeemSportsAccess}
          textStyle={themeContext.SportsAccessFlow.SportsAccessRedeemButtonText}
        />
      </SportsAccessButtons>
    </SportsAccessContainer>
  );
};

export default SportsAccessFlow;

